import { Tab, TabProps } from '@mui/material';
import React from 'react';
interface ProfileTabProps extends TabProps {
  label: string;
}

const ProfileTab: React.FC<ProfileTabProps> = ({ label, ...props }) => (
  <Tab
    label={label}
    sx={{
      textTransform: 'none',
      textAlign: 'left',
      alignItems: 'flex-start',
      padding: 2,
      paddingLeft: 4,
      fontWeight: 'bold',
    }}
    {...props}
  />
);

export default ProfileTab;
